<div
  *ngFor="let event of events"
  class="calendarprintlistcountry__event flex-row-start"
>
  <div class="calendarprintlistcountry__countryname">{{ country?.name }}</div>
  <div
    class="calendarprintlistcountry__eventname"
    [class.is-holiday]="event.event_type?.slug === 'holidays' || event.event_type?.slug === 'local-holidays'"
  >
    <span class="calendarprintlistcountry__eventname--header">{{
      event.name
    }}</span>
    <div
      class="calendarprintlistcountry__eventdescription"
      *ngIf="event.event_type?.slug !== 'holidays' && event.event_type?.slug !== 'local-holidays'"
    >
      <ng-container *ngIf="!event.section">{{ event.description }}</ng-container>
      <span *ngIf="event.section">See Country Profile for details</span>
    </div>
    <div
      class="calendarprintlistcountry__eventlabel"
      *ngIf="event.event_type?.slug === 'holidays' || event.event_type?.slug === 'local-holidays'"
    >
      Public Holiday
    </div>
    <div class="calendarprintlistcountry__eventlabel" *ngIf="event.event_type">
      {{ event.event_type.name }}
    </div>
  </div>
</div>
